import React, { useEffect, useRef, useState } from "react";

const STATS = [
  { num: 10, suffix: "+", label: "Years of experience" },
  { num: 60, suffix: "+", label: "Shipped projects" },
  { num: 30, suffix: "+", label: "Shopify stores" },
  { num: 99, suffix: "%", label: "Client retention" },
];

function useCounter(target, run) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!run) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const step = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, run]);
  return val;
}

function Stat({ data, run }) {
  const v = useCounter(data.num, run);
  return (
    <div className="stat">
      <div className="num">
        {v}
        <em>{data.suffix}</em>
      </div>
      <div className="label">{data.label}</div>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [run, setRun] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setRun(true);
          io.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="section section--tight">
      <div className="container-x">
        <div ref={ref} className="stats reveal">
          {STATS.map((s, i) => (
            <Stat key={i} data={s} run={run} />
          ))}
        </div>
      </div>
    </section>
  );
}
